import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function FundingSystemReschedulesForm({ fundingRescheduleCounter }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>System Reschedules:</Form.Label>
      </Col>
      <Col md={1} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="rescheduleCounter"
          id="rescheduleCounter"
          value={fundingRescheduleCounter}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingSystemReschedulesForm);
